
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cancellation-policy",
      function () {
        return require("private-next-pages/cancellation-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cancellation-policy"])
      });
    }
  